import {useCallback} from 'react'
import {queryForRepos} from './useCopilotRepoFetching'

/**
 * Hook that provides a repository loader function that automatically includes
 * a repository owner as defaultOwner for organization-scoped searches
 *
 * @param defaultOwner Owner login to use for scoped repository searches
 */
export function useDefaultOwnerAwareRepositoryLoader(defaultOwner?: string) {
  return useCallback(
    (query: string) => {
      // Pass the provided defaultOwner for organization-scoped searches
      // This works for both organizations and users since the backend supports both
      return queryForRepos(query, defaultOwner)
    },
    [defaultOwner],
  )
}
